import React, { useState } from 'react';
import Reveal from '../components/Reveal/Reveal';
import './FAQ.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const faqCategories = [
    {
      title: 'À Propos de l\'ADEEF',
      items: [
        {
          question: 'Qu\'est-ce que l\'ADEEF ?',
          answer: 'L\'ADEEF (Association des Étudiants Égyptiens en France) est une association qui accompagne les étudiants égyptiens dans leur parcours en France. Notre mission est de faciliter votre intégration, vous soutenir dans vos démarches administratives et académiques, et promouvoir la culture égyptienne en France.'
        },
        {
          question: 'Quelle est la mission de l\'ADEEF ?',
          answer: 'Notre objectif est de :\n• Faciliter l\'installation des étudiants égyptiens en France\n• Offrir un accompagnement administratif et académique\n• Informer sur les opportunités de bourses\n• Organiser des événements culturels et sociaux\n• Favoriser l\'entraide et la création d\'un réseau entre étudiants\n\nNous sommes présents pour vous accompagner tout au long de votre parcours académique et personnel.'
        },
        {
          question: 'Quels services propose l\'ADEEF ?',
          answer: 'Support et assistance : Nous répondons à vos questions concernant les démarches administratives (titre de séjour, CAF, sécurité sociale, etc.), la vie étudiante en France, l\'installation et l\'adaptation au système français.\n\nInformations sur les bourses : Nous partageons régulièrement des opportunités de financement pour vos études.\n\nÉvénements : Nous organisons des rencontres entre étudiants, des événements culturels, des activités favorisant l\'intégration, des concerts et moments de convivialité.\n\nLogement étudiant : Nous avons un partenariat avec Nexity Studéa, leader du logement étudiant en France.'
        }
      ]
    },
    {
      title: 'Logement',
      items: [
        {
          question: 'Pourquoi passer par l\'ADEEF pour trouver un logement ?',
          answer: 'Grâce à notre partenariat avec Nexity Studéa, vous bénéficiez de plusieurs avantages :\n• Pas besoin de garant : l\'ADEEF se porte garant pour vous\n• Réduction sur les frais de dossier\n• Procédure simplifiée\n• Logements accessibles partout en France métropolitaine\n\nCela facilite considérablement votre installation en France. Vous pouvez faire votre demande directement sur ce site.'
        },
        {
          question: 'Dois-je prendre une assurance habitation ?',
          answer: 'Oui, elle est obligatoire pour tout logement étudiant.'
        },
        {
          question: 'Dois-je ouvrir un compte bancaire français ?',
          answer: 'Oui. Il est nécessaire pour la CAF, le remboursement santé, le paiement du loyer et les abonnements.'
        }
      ]
    },
    {
      title: 'Titre de Séjour et Voyages',
      items: [
        {
          question: 'Puis-je voyager en Égypte et revenir en France avec une attestation de décision favorable avant de récupérer mon titre de séjour ?',
          answer: 'Oui, il est possible de voyager avec une attestation de décision favorable avant de récupérer votre carte de séjour.\n\nCependant, nous recommandons fortement :\n• De prendre uniquement des vols directs entre la France et l\'Égypte\n• D\'éviter tout transit dans un autre pays\n\nLes vols directs réduisent les risques de complications lors des contrôles.'
        },
        {
          question: 'Peut-on se rendre à la préfecture sans rendez-vous ?',
          answer: 'Non. La préfecture fonctionne uniquement sur rendez-vous. Il est obligatoire de prendre rendez-vous en ligne avant de vous déplacer.'
        },
        {
          question: 'Puis-je récupérer mon titre de séjour en retard si j\'ai oublié d\'aller le chercher après sa fabrication ?',
          answer: 'En principe, vous devez récupérer votre titre de séjour dans le délai indiqué par la préfecture.\n\nSi vous avez dépassé le délai (par exemple après 3 mois), vous devez :\n• Contacter rapidement votre préfecture\n• Vérifier si votre titre est toujours disponible\n\nDans certains cas, si le délai est trop long, le titre peut être renvoyé ou annulé, ce qui pourrait vous obliger à refaire certaines démarches. Il est donc fortement recommandé de récupérer votre titre dès que vous recevez la notification.'
        },
        {
          question: 'Dois-je faire la validation OFII ?',
          answer: 'Oui, c\'est obligatoire pour tous les détenteurs d\'un visa long séjour.\n\nSans validation OFII :\n• Votre séjour n\'est pas régularisé\n• Vous pouvez avoir des problèmes administratifs'
        }
      ]
    },
    {
      title: 'Démarches Administratives',
      items: [
        {
          question: 'Comment s\'inscrire à la sécurité sociale étudiante ?',
          answer: 'Après votre arrivée, vous devez vous inscrire gratuitement sur : etudiant-etranger.ameli.fr\n\nVous recevrez ensuite votre numéro de sécurité sociale.'
        }
      ]
    },
    {
      title: 'Travail et Études',
      items: [
        {
          question: 'Puis-je travailler pendant mes études ?',
          answer: 'Oui, jusqu\'à 964 heures par an (environ 20h/semaine).'
        }
      ]
    }
  ];

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Filter FAQ items based on search query
  const filteredCategories = faqCategories.map(category => ({
    ...category,
    items: category.items.filter(item => 
      searchQuery === '' || 
      item.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.answer.toLowerCase().includes(searchQuery.toLowerCase())
    )
  })).filter(category => category.items.length > 0);

  return (
    <div className="faq-page">
      {/* Hero Section */}
      <section className="faq-hero">
        <Reveal as="div" className="hero-content" variant="up">
          <h1>Foire Aux Questions</h1>
          <p>Trouvez rapidement les réponses à vos questions</p>
        </Reveal>
      </section>

      {/* Search Section */}
      <Reveal as="section" className="search-section" variant="up" delay={60}>
        <div className="container">
          <div className="section-card">
            <div className="search-box">
              <input 
                type="text" 
                placeholder="Rechercher une question..."
                className="search-input"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button className="search-btn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="m21 21-4.35-4.35"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </Reveal>

      {/* FAQ Content */}
      <Reveal as="section" className="faq-content" variant="up" delay={80}>
        <div className="container">
          <div className="section-card">
            {filteredCategories.length === 0 ? (
              <p style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-medium)' }}>
                Aucun résultat trouvé pour "{searchQuery}"
              </p>
            ) : (
              filteredCategories.map((category, catIndex) => (
              <div key={catIndex} className="faq-category">
                <h2 className="category-title">{category.title}</h2>
                <div className="faq-list">
                  {category.items.map((item, itemIndex) => {
                    const globalIndex = `${catIndex}-${itemIndex}`;
                    return (
                      <div 
                        key={itemIndex} 
                        className={`faq-item ${openIndex === globalIndex ? 'open' : ''}`}
                      >
                        <button 
                          className="faq-question"
                          onClick={() => toggleQuestion(globalIndex)}
                        >
                          <span>{item.question}</span>
                          <span className="faq-icon">{openIndex === globalIndex ? '−' : '+'}</span>
                        </button>
                        <div className="faq-answer">
                          <p>{item.answer}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))
            )}
          </div>
        </div>
      </Reveal>
    </div>
  );
};

export default FAQ;
